import * as React from "react";
const SvgFiRrLightbulbQuestion = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lightbulb-question_svg__a)">
      <path
        fill="#062147"
        d="M14.953 6.466a3.01 3.01 0 0 1-1.506 3.163C13 9.875 13 9.947 13 10a1 1 0 1 1-2 0c0-1.308 1.038-1.879 1.481-2.123.289-.16.595-.535.502-1.065a1 1 0 0 0-.793-.794.98.98 0 0 0-.832.216 1 1 0 0 0-.358.767 1 1 0 1 1-2 0c0-.889.391-1.727 1.072-2.299a2.99 2.99 0 0 1 2.464-.653 3.02 3.02 0 0 1 2.417 2.417M12 12a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3m9-3a9 9 0 0 1-3.068 6.764C16.686 16.856 16 18.276 16 19.762v.548A3.694 3.694 0 0 1 12.31 24h-.619a3.694 3.694 0 0 1-3.69-3.69v-.16c0-1.666-.757-3.288-2.132-4.566-2.149-2-3.167-4.829-2.793-7.762C3.59 3.782 6.904.517 10.956.06a9.06 9.06 0 0 1 7.038 2.23A9.01 9.01 0 0 1 21 9m-7 11.31V20H9.998l.002.15v.16c0 .931.759 1.69 1.69 1.69h.619c.932 0 1.69-.76 1.69-1.69zM19 9a7.01 7.01 0 0 0-2.338-5.222A6.92 6.92 0 0 0 12.008 2q-.41 0-.827.047c-3.147.355-5.722 2.891-6.121 6.027-.292 2.285.5 4.488 2.171 6.045C8.432 15.235 9.269 16.57 9.689 18h4.548c.378-1.4 1.199-2.709 2.377-3.74A7 7 0 0 0 19 9"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lightbulb-question_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLightbulbQuestion;
